var render = function render(){var _vm=this,_c=_vm._self._c;return _c('moved-notice',{attrs:{"title":_vm.target.title,"url":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }